export enum RolesEnum {
  JOB_SEEKER = 'jobSeeker',
  RECRUITER = 'recruiter',
  GUEST = 'guest',
}
